var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-navbar",
    {
      staticClass: "jh-navbar",
      attrs: { "data-cy": "navbar", toggleable: "md", type: "dark" },
    },
    [
      _c(
        "b-navbar-brand",
        { staticClass: "logo", attrs: { "b-link": "", to: "/" } },
        [
          _c("span", { staticClass: "logo-img" }),
          _vm._v(" "),
          _c("div", { staticClass: "logo-txt" }, [
            _c("h1", [
              _vm._v("Asociación Cooperadora"),
              _c("br"),
              _vm._v("del Bachillerato de Bellas Artes"),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("Universidad Nacional de La Plata")]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }